import { createAction } from '@reduxjs/toolkit';
export const storeStartFailed = createAction('STORE_START_FAILED');
export const requestFailed = createAction('REQUEST_FAILED');
export const resetStateBetweenCallObjects = createAction('resetStateBetweenCallObjects');